import { connect } from 'react-redux'

import _banner from '../components/banner'

const mapStateToProps = ({
  pages: {
    banners,
  },
  mediaQuery: {
    screen,
  },
}) => {
  return {
    banners,
    screen,
  }
}

export default connect(mapStateToProps, null)(_banner)



// WEBPACK FOOTER //
// ./src/containers/Banner.js